import React from "react";
import "./Service.css";
import video1 from "../Assests/3.png";
import video2 from "../Assests/2.png";
import video3 from "../Assests/4.png";
import video4 from "../Assests/5.png";

const Service = () => {
  return (
    <div className="service-container">
      {/* Title */}
      <h2 className="service-title">Why-Us?</h2>

      <div className="service-grid">
        {/* Card 1 */}
        <div className="service-card">
          <img src={video1} alt="Service Image" className="service-image" />

          <h4 className="serivce-tittle">Exclusively for hospital</h4>
        </div>

        {/* Card 2 */}
        <div className="service-card">
        <img src={video2} alt="Service Image" className="service-image" />
          <h4 className="serivce-tittle">Ethical Drugs</h4>
        </div>

        {/* Card 3 */}
        <div className="service-card">
        <img src={video3} alt="Service Image" className="service-image" />
          <h4 className="serivce-tittle">Institutional Price</h4>
        </div>

        {/* Card 4 */}
        <div className="service-card">
        <img src={video4} alt="Service Image" className="service-image" />
          <h4 className="serivce-tittle">Latest Innovation</h4>
        </div>
      </div>
    </div>
  );
};

export default Service;
